// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Custom styles for React Quill Editor in Vision & Mission */

.ql-toolbar {
  background-color: #f8f9fa !important;
  border: 1px solid #dee2e6 !important;
  border-top-left-radius: 0.5rem !important;
  border-top-right-radius: 0.5rem !important;
  padding: 12px !important;
}

.ql-container {
  border: 1px solid #dee2e6 !important;
  border-top: none !important;
  border-bottom-left-radius: 0.5rem !important;
  border-bottom-right-radius: 0.5rem !important;
  font-size: 15px !important;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif !important;
  min-height: 150px;
}

.ql-editor {
  min-height: 150px;
  padding: 12px 15px !important;
}

.ql-editor.ql-blank::before {
  color: #9ca3af !important;
  font-style: normal !important;
}

/* Toolbar button styles */
.ql-toolbar button {
  width: 32px !important;
  height: 32px !important;
  margin: 0 2px !important;
}

.ql-toolbar button:hover {
  background-color: #e9ecef !important;
  border-radius: 4px !important;
}

.ql-toolbar button.ql-active {
  background-color: #dc2626 !important;
  color: white !important;
  border-radius: 4px !important;
}

.ql-toolbar .ql-stroke {
  stroke: #374151 !important;
}

.ql-toolbar .ql-fill {
  fill: #374151 !important;
}

.ql-toolbar button.ql-active .ql-stroke {
  stroke: white !important;
}

.ql-toolbar button.ql-active .ql-fill {
  fill: white !important;
}

/* Dropdown styles */
.ql-toolbar select {
  border: 1px solid #dee2e6 !important;
  border-radius: 4px !important;
  padding: 4px 8px !important;
  background-color: white !important;
}

.ql-toolbar select:focus {
  border-color: #dc2626 !important;
  outline: none !important;
}

/* Color picker */
.ql-toolbar .ql-picker-label {
  border: 1px solid transparent !important;
  padding: 2px 4px !important;
}

.ql-toolbar .ql-picker-label:hover {
  background-color: #e9ecef !important;
  border-radius: 4px !important;
}

.ql-toolbar .ql-picker.ql-expanded .ql-picker-label {
  background-color: #e9ecef !important;
  border-radius: 4px !important;
}

/* Focus state */
.ql-container.ql-snow.ql-focused {
  border-color: #dc2626 !important;
  box-shadow: 0 0 0 3px rgba(220, 38, 38, 0.1) !important;
}

/* Editor content styles */
.ql-editor h1 {
  font-size: 2em !important;
  font-weight: bold !important;
  margin-bottom: 0.5em !important;
}

.ql-editor h2 {
  font-size: 1.5em !important;
  font-weight: bold !important;
  margin-bottom: 0.5em !important;
}

.ql-editor h3 {
  font-size: 1.25em !important;
  font-weight: bold !important;
  margin-bottom: 0.5em !important;
}

.ql-editor ul,
.ql-editor ol {
  padding-left: 1.5em !important;
  margin-bottom: 1em !important;
}

.ql-editor blockquote {
  border-left: 4px solid #dc2626 !important;
  padding-left: 16px !important;
  margin-left: 0 !important;
  color: #6b7280 !important;
  font-style: italic !important;
}

.ql-editor pre.ql-syntax {
  background-color: #f3f4f6 !important;
  border-radius: 4px !important;
  padding: 12px !important;
  overflow-x: auto !important;
  margin-bottom: 1em !important;
}

.ql-editor a {
  color: #2563eb !important;
  text-decoration: underline !important;
}

.ql-editor img {
  max-width: 100% !important;
  height: auto !important;
  margin-bottom: 1em !important;
}
`, "",{"version":3,"sources":["webpack://./src/pages/admin/ManageVisionMission.css"],"names":[],"mappings":"AAAA,6DAA6D;;AAE7D;EACE,oCAAoC;EACpC,oCAAoC;EACpC,yCAAyC;EACzC,0CAA0C;EAC1C,wBAAwB;AAC1B;;AAEA;EACE,oCAAoC;EACpC,2BAA2B;EAC3B,4CAA4C;EAC5C,6CAA6C;EAC7C,0BAA0B;EAC1B,yKAAyK;EACzK,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;EACE,yBAAyB;EACzB,6BAA6B;AAC/B;;AAEA,0BAA0B;AAC1B;EACE,sBAAsB;EACtB,uBAAuB;EACvB,wBAAwB;AAC1B;;AAEA;EACE,oCAAoC;EACpC,6BAA6B;AAC/B;;AAEA;EACE,oCAAoC;EACpC,uBAAuB;EACvB,6BAA6B;AAC/B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,sBAAsB;AACxB;;AAEA,oBAAoB;AACpB;EACE,oCAAoC;EACpC,6BAA6B;EAC7B,2BAA2B;EAC3B,kCAAkC;AACpC;;AAEA;EACE,gCAAgC;EAChC,wBAAwB;AAC1B;;AAEA,iBAAiB;AACjB;EACE,wCAAwC;EACxC,2BAA2B;AAC7B;;AAEA;EACE,oCAAoC;EACpC,6BAA6B;AAC/B;;AAEA;EACE,oCAAoC;EACpC,6BAA6B;AAC/B;;AAEA,gBAAgB;AAChB;EACE,gCAAgC;EAChC,uDAAuD;AACzD;;AAEA,0BAA0B;AAC1B;EACE,yBAAyB;EACzB,4BAA4B;EAC5B,+BAA+B;AACjC;;AAEA;EACE,2BAA2B;EAC3B,4BAA4B;EAC5B,+BAA+B;AACjC;;AAEA;EACE,4BAA4B;EAC5B,4BAA4B;EAC5B,+BAA+B;AACjC;;AAEA;;EAEE,8BAA8B;EAC9B,6BAA6B;AAC/B;;AAEA;EACE,yCAAyC;EACzC,6BAA6B;EAC7B,yBAAyB;EACzB,yBAAyB;EACzB,6BAA6B;AAC/B;;AAEA;EACE,oCAAoC;EACpC,6BAA6B;EAC7B,wBAAwB;EACxB,2BAA2B;EAC3B,6BAA6B;AAC/B;;AAEA;EACE,yBAAyB;EACzB,qCAAqC;AACvC;;AAEA;EACE,0BAA0B;EAC1B,uBAAuB;EACvB,6BAA6B;AAC/B","sourcesContent":["/* Custom styles for React Quill Editor in Vision & Mission */\n\n.ql-toolbar {\n  background-color: #f8f9fa !important;\n  border: 1px solid #dee2e6 !important;\n  border-top-left-radius: 0.5rem !important;\n  border-top-right-radius: 0.5rem !important;\n  padding: 12px !important;\n}\n\n.ql-container {\n  border: 1px solid #dee2e6 !important;\n  border-top: none !important;\n  border-bottom-left-radius: 0.5rem !important;\n  border-bottom-right-radius: 0.5rem !important;\n  font-size: 15px !important;\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif !important;\n  min-height: 150px;\n}\n\n.ql-editor {\n  min-height: 150px;\n  padding: 12px 15px !important;\n}\n\n.ql-editor.ql-blank::before {\n  color: #9ca3af !important;\n  font-style: normal !important;\n}\n\n/* Toolbar button styles */\n.ql-toolbar button {\n  width: 32px !important;\n  height: 32px !important;\n  margin: 0 2px !important;\n}\n\n.ql-toolbar button:hover {\n  background-color: #e9ecef !important;\n  border-radius: 4px !important;\n}\n\n.ql-toolbar button.ql-active {\n  background-color: #dc2626 !important;\n  color: white !important;\n  border-radius: 4px !important;\n}\n\n.ql-toolbar .ql-stroke {\n  stroke: #374151 !important;\n}\n\n.ql-toolbar .ql-fill {\n  fill: #374151 !important;\n}\n\n.ql-toolbar button.ql-active .ql-stroke {\n  stroke: white !important;\n}\n\n.ql-toolbar button.ql-active .ql-fill {\n  fill: white !important;\n}\n\n/* Dropdown styles */\n.ql-toolbar select {\n  border: 1px solid #dee2e6 !important;\n  border-radius: 4px !important;\n  padding: 4px 8px !important;\n  background-color: white !important;\n}\n\n.ql-toolbar select:focus {\n  border-color: #dc2626 !important;\n  outline: none !important;\n}\n\n/* Color picker */\n.ql-toolbar .ql-picker-label {\n  border: 1px solid transparent !important;\n  padding: 2px 4px !important;\n}\n\n.ql-toolbar .ql-picker-label:hover {\n  background-color: #e9ecef !important;\n  border-radius: 4px !important;\n}\n\n.ql-toolbar .ql-picker.ql-expanded .ql-picker-label {\n  background-color: #e9ecef !important;\n  border-radius: 4px !important;\n}\n\n/* Focus state */\n.ql-container.ql-snow.ql-focused {\n  border-color: #dc2626 !important;\n  box-shadow: 0 0 0 3px rgba(220, 38, 38, 0.1) !important;\n}\n\n/* Editor content styles */\n.ql-editor h1 {\n  font-size: 2em !important;\n  font-weight: bold !important;\n  margin-bottom: 0.5em !important;\n}\n\n.ql-editor h2 {\n  font-size: 1.5em !important;\n  font-weight: bold !important;\n  margin-bottom: 0.5em !important;\n}\n\n.ql-editor h3 {\n  font-size: 1.25em !important;\n  font-weight: bold !important;\n  margin-bottom: 0.5em !important;\n}\n\n.ql-editor ul,\n.ql-editor ol {\n  padding-left: 1.5em !important;\n  margin-bottom: 1em !important;\n}\n\n.ql-editor blockquote {\n  border-left: 4px solid #dc2626 !important;\n  padding-left: 16px !important;\n  margin-left: 0 !important;\n  color: #6b7280 !important;\n  font-style: italic !important;\n}\n\n.ql-editor pre.ql-syntax {\n  background-color: #f3f4f6 !important;\n  border-radius: 4px !important;\n  padding: 12px !important;\n  overflow-x: auto !important;\n  margin-bottom: 1em !important;\n}\n\n.ql-editor a {\n  color: #2563eb !important;\n  text-decoration: underline !important;\n}\n\n.ql-editor img {\n  max-width: 100% !important;\n  height: auto !important;\n  margin-bottom: 1em !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
